import { Box, Skeleton } from '@chakra-ui/react';
import { AdminLayout } from '@diamond/sol-admin/components';

export function VoucherLoadingSkeleton() {
  return (
    <AdminLayout>
      <Box py={4}>
        <Skeleton height="580px" borderRadius="md" />
      </Box>
    </AdminLayout>
  );
}
